import { render, staticRenderFns } from "./KitModal.vue?vue&type=template&id=7d51179c&scoped=true"
import script from "./KitModal.vue?vue&type=script&lang=js"
export * from "./KitModal.vue?vue&type=script&lang=js"
import style0 from "./KitModal.vue?vue&type=style&index=0&id=7d51179c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d51179c",
  null
  
)

export default component.exports